import api from "./apiSmartLogistics.js";

export default {
  GetViewUsersCustomers() {
    return api.get("ViewUsersCustomersUsersCustomers/GetViewUsersCustomers");
  },

  GetViewUserCustomer(Id) {
    return api.get(
      "ViewUsersCustomersUsersCustomers/GetViewUserCustomer/" + Id
    );
  },

  InsertViewUsersCustomers(userCustomer) {
    return api.post(
      "ViewUsersCustomersUsersCustomers/InsertViewUsersCustomers",
      userCustomer
    );
  },

  UpdateViewUsersCustomers(userCustomer) {
    return api.put(
      "ViewUsersCustomersUsersCustomers/UpdateViewUserCustomer",
      userCustomer
    );
  },

  DeleteViewUsersCustomers(Id) {
    return api.delete(
      "ViewUsersCustomersUsersCustomers/DeleteViewUsersCustomers/" + Id
    );
  }
};
